// Key/value config surfaced from the admin panel (Social Media tab, etc.).
// Degrades to empty object if the migration hasn't been applied yet — the
// footer's social row stays hidden in that case.

import { supabase } from './supabase.js';

const SOCIAL_KEYS = [
  'social_instagram',
  'social_facebook',
  'social_twitter',
  'social_youtube',
  'social_linkedin',
  'social_whatsapp',
];

export { SOCIAL_KEYS };

export async function fetchSiteSettings() {
  const { data, error } = await supabase
    .from('site_settings')
    .select('key, value');
  if (error) return { data: {}, error };
  const map = {};
  for (const row of data || []) map[row.key] = row.value || '';
  return { data: map, error: null };
}

export async function updateSiteSettings(entries) {
  // entries: { key: value, ... } — upserts each row independently so a
  // single failure doesn't roll back the rest.
  const rows = Object.entries(entries).map(([key, value]) => ({
    key,
    value: (value || '').trim(),
  }));
  if (!rows.length) return { data: [], error: null };
  const { data, error } = await supabase
    .from('site_settings')
    .upsert(rows, { onConflict: 'key' })
    .select();
  return { data: data || [], error: error || null };
}
